import { render, staticRenderFns } from "./downLoad.vue?vue&type=template&id=c871fd96&scoped=true&"
import script from "./downLoad.vue?vue&type=script&lang=js&"
export * from "./downLoad.vue?vue&type=script&lang=js&"
import style0 from "./downLoad.vue?vue&type=style&index=0&id=c871fd96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c871fd96",
  null
  
)

export default component.exports